import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { Response, Filters, FiltersPagination } from '@/types';
import { AxiosResponse } from 'axios';
import { StaffsService } from '../services';
import { InviteUserData, Staffs } from '../types';
import StaffGetters from './getters';
import StaffMutations from './mutations';
import StaffState from './state';

const staffService = new StaffsService();

export default class StaffActions extends Actions<
  StaffState,
  StaffGetters,
  StaffMutations,
  StaffActions
> {
  async get_staffs(payload?: {
    is_active?: boolean;
    storage_limit?: number;
  }) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const { all_staffs } = this.state;
      const currentPayload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: payload?.storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [currentPayload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        currentPayload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_STAFFS(true);
      const { data, meta } = await staffService.get_staffs(currentPayload, all_staffs, payload?.is_active);

      this.mutations.SET_STAFFS(data.items);
      this.mutations.SET_CITIES(data.cities);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_STAFFS(false);
    }
  }

  async get_staff(id: string | number) {
    try {
      const { data } = await staffService.get_staff(id);

      this.mutations.SET_CURRENT_STAFF(data);
    } catch (error) {
      console.log(error);
    }
  }

  async send_invite(payload: InviteUserData): Promise<Response<Staffs.Staff> | AxiosResponse> {
    try {
      const data = await staffService.send_invite(payload);

      return data as Response<Staffs.Staff>;
    } catch (error) {
      return error as AxiosResponse;
    }
  }

  async resending_invite(id: number): Promise<number | undefined> {
    try {
      const { code = ResponseStatuses.Success.UPDATED } = await staffService.resending_invite(id);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async deleting_invite(id: number) {
    try {
      return await staffService.deleting_invite(id);
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async change_role() {
    const staff_id = Number(this.state.staff_for_role_changing.id);
    let code = null;

    if (this.state.changing_info.code) {
      code = this.state.changing_info.code;
    }

    try {
      const data = await staffService.change_role(staff_id, code);

      return data.code;
    } catch (error) {
      console.log(error);
      const { data }: any = error;

      if (error) {
        this.state.transfer_role_error_message = data.message;
        return data.code;
      }
    }
  }
}
